module.exports = __webpack_public_path__ + "img/TORTAS.31aa1764.png";